<template>
  <div class="p_market_module p_market_lead">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">企业</div>
            <el-input v-model="listQuery.strEntName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput" v-if="activeName == 'second'||activeName == 'five'||activeName == 'four'">
            <div class="flname">岗位</div>
            <el-input v-model="listQuery.strJobName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">地区</div>
            <el-input v-model="listQuery.strAddr" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput" v-if="activeName == 'six'&&(isCanViewClue&&isVip)">
            <el-checkbox v-model="listQuery.followtypeCheck" @change="bdChange">BD服务</el-checkbox>
            <!-- <el-radio-group v-if="isVip" v-model="listQuery.followtype" class="m_checks" @change="changeHandler">
              <el-radio :label="'BD服务'"></el-radio>
            </el-radio-group> -->
          </div>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? "收起" : "更多"
                }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" :disabled="tableLoading" type="success" size="small" @click="searchHandle" :style="!isNull(tableData) ? '' : 'margin-right:16px'" style="margin-right: 15px">搜索</el-button>
        <!-- <el-button v-if="tableData.length>0" type="warning" plain size="small" @click="exportHandle" :loading="btnLoading" style="margin-right:16px">导出</el-button> -->
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="来源:">
            <el-select v-model="listQuery.strplatform" size="small" placeholder="" clearable>
              <el-option v-for="(item, index) in platformList" :key="index + 'b'" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户意向:" v-if="activeName != 'second'&&activeName != 'five'&&activeName != 'four'">
            <el-select v-model="listQuery.strintention" size="small" placeholder="" clearable>
              <el-option label="有意向" value="有意向"></el-option>
              <el-option label="无意向" value="无意向"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="认领状态:" v-if="activeName == 'seven'">
            <el-select v-model="listQuery.strClaimstu" size="small" placeholder="" clearable>
              <el-option label="未认领" value="0"></el-option>
              <el-option label="已认领" value="1"></el-option>
            </el-select>
          </el-form-item>
          <!-- label-width="68px" -->
          <el-form-item label="企业规模:">
            <el-select v-model="listQuery.StrEntScale" size="small" placeholder="" clearable>
              <el-option v-for="(item, index) in scaleList" :key="index + 'b'" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="招聘企业类型:" v-if="activeName == 'five'||activeName == 'four'">
            <el-select filterable v-model="listQuery.strEnttype" placeholder="" size="small" clearable>
              <el-option v-for="(item, index) in typeList" :key="index + 'c'" :label="item.Basname" :value="item.Basname"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="行业:">
            <el-input v-model="listQuery.StrEntIndustry" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="当前需求:" v-if="activeName != 'second'&&activeName != 'five'&&activeName != 'four'">
            <el-select v-model="listQuery.strdemand" size="small" placeholder="" clearable>
              <el-option label="有" value="有"></el-option>
              <el-option label="无" value="无"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跟进人:" v-if="activeName=='全部跟进'">
            <el-input v-model="listQuery.followusername" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="认领人:" v-if="activeName=='全部认领'">
            <el-input v-model="listQuery.claimusername" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="跟进时间:" v-if="activeName == 'seven' || activeName == '全部跟进' || activeName == 'six'" style="width:100%" class="f_cont_box">
            <div class="t_down_box">
              <el-date-picker size="small" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="listQuery.followdatestart" type="date" placeholder=""></el-date-picker>
              <span>-</span>
              <el-date-picker size="small" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="listQuery.followdateent" type="date" placeholder=""></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="认领时间:" v-if="activeName == 'eight' || activeName == '全部认领'" style="width:100%" class="f_cont_box">
            <div class="t_down_box">
              <el-date-picker size="small" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="listQuery.claimdatestart" type="date" placeholder=""></el-date-picker>
              <span>-</span>
              <el-date-picker size="small" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="listQuery.claimdateend" type="date" placeholder=""></el-date-picker>
            </div>
          </el-form-item>
          <!-- <el-form-item label="跟进状态:" v-if="activeName == 'third'" label-width="68px">
            <el-select filterable v-model="listQuery.AddTelFollow" placeholder="" size="small" clearable>
              <el-option label="已跟进" value="1"></el-option>
              <el-option label="未跟进" value="0"></el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button :disabled="tableLoading" size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>营销雷达</el-breadcrumb-item>
          <el-breadcrumb-item>线索查看</el-breadcrumb-item>
          <el-breadcrumb-item v-if="activeName == 'second'">CRM雷达监测</el-breadcrumb-item>
          <el-breadcrumb-item v-if="activeName == 'five'">线索(公海)</el-breadcrumb-item>
          <el-breadcrumb-item v-if="activeName == 'six'">跟进(公海)</el-breadcrumb-item>
          <el-breadcrumb-item v-if="activeName == 'seven'">我的跟进</el-breadcrumb-item>
          <el-breadcrumb-item v-if="activeName == 'eight'">我的认领</el-breadcrumb-item>
          <el-breadcrumb-item v-if="activeName == 'four'">猎头线索</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_clue_box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="线索(公海)" name="five" v-if="isCanViewClue" :disabled="tableLoading"></el-tab-pane>
          <el-tab-pane label="跟进(公海)" name="six" v-if="isCanViewClue" :disabled="tableLoading"></el-tab-pane>
          <el-tab-pane label="我的跟进" name="seven" v-if="isCanViewClue" :disabled="tableLoading"></el-tab-pane>
          <el-tab-pane label="我的认领" name="eight" v-if="isCanViewClue" :disabled="tableLoading"></el-tab-pane>
          <el-tab-pane label="CRM雷达监测" name="second" :disabled="tableLoading"></el-tab-pane>
          <el-tab-pane label="全部跟进" name="全部跟进" v-if="isCanViewClue && IsdataAdmin=='1'" :disabled="tableLoading"></el-tab-pane>
          <el-tab-pane label="全部认领" name="全部认领" v-if="isCanViewClue && IsdataAdmin=='1'" :disabled="tableLoading"></el-tab-pane>
          <!-- 管理员 -->
          <!-- <el-tab-pane label="线索雷达监测" name="third" v-if="isCanViewClue" :disabled="tableLoading"></el-tab-pane> -->
          <el-tab-pane label="猎头线索" name="four" v-if="isCanViewHunt" :disabled="tableLoading"></el-tab-pane>
        </el-tabs>
        <el-table ref="clueTable" class="re_table" border v-loading="tableLoading" @sort-change="sortHandle" :highlight-current-row="true" :max-height="tableHeight - 100" :data="tableData" @cell-dblclick="editAreaInfo" style="width: 100%">
          <el-table-column v-if="activeName != 'second'" align="center" label="序号" width="60px" fit :show-overflow-tooltip="true" fixed>
            <template slot-scope="{$index}">
              <span>{{(Number(listQuery.currpage) - 1) * Number(listQuery.perpage) + Number($index) + 1}}</span>
            </template>
          </el-table-column>
          <template v-for="(item, index) in tableTitle">
            <el-table-column :prop="item.StrColumId" :fixed="
                (item.StrColumId == 'StrQue' ||
                item.StrColumId == 'StrEntNice' ||
                item.StrColumId == 'StrJobName')?'left':((item.StrColumName == '联系人' && activeName != 'second')?'right':false)
              " :sortable="
                item.StrColumName == '缺口'
                  ? 'custom'
                  : false
              " :label="item.StrColumName" fit :show-overflow-tooltip="
                item.StrColumName == '联系人' ? false : true
              " :key="index" v-if="item.StrColumName != '联系方式'" :min-width="
                item.StrColumName.indexOf('序号') > -1
                  ? '60px'
                  : item.StrColumName.indexOf('全称') > -1
                  ? '250px'
                  : item.StrColumName.indexOf('简称') > -1 ||
                    item.StrColumName.indexOf('时间') > -1 ||
                    item.StrColumName.indexOf('公海') > -1
                  ? '160px'
                  : item.StrColumName.indexOf('缺口') > -1
                  ? '72px'
                  : '100px'
              " align="center">
              <template slot-scope="scope">
                <span v-if="item.StrColumId == 'StrSource'" title="点击可跳转详情" @click="jumpOtherNet(scope.row.StrNation)" class="j_url_txt">{{
                    isNull(scope.row[item.StrColumId])? "": scope.row[item.StrColumId]
                  }}</span>
                <span class="contacts cp" v-else-if="
                    item.StrColumName == '联系人' && activeName != 'second'
                  ">
                  <el-popover :popper-class="(scope.row.isThirdTel == 'sure' && !isContactsByOther)?'market_popover_box':''" placement="left" :width="isContactsByOther ? 150 : 641" trigger="click" :ref="`popover-${scope.row.StrQue}`">
                    <!-- 查询联系方式数据 -->
                    <el-table class="p_pop_box" v-show="!isContactsByOther" :data="contactsList" v-loading="contactsLoading" border>
                      <el-table-column min-width="100px" property="entname" label="企业全称" fit :show-overflow-tooltip="true" align="center"></el-table-column>
                      <el-table-column min-width="100px" property="ContactPerson" label="联系人" fit :show-overflow-tooltip="true" align="center"></el-table-column>
                      <el-table-column min-width="100px" property="ContactPsnpost" label="职位" fit :show-overflow-tooltip="true" align="center"></el-table-column>
                      <el-table-column min-width="110px" property="TelNum" label="联系方式" fit :show-overflow-tooltip="true" align="center"></el-table-column>
                      <el-table-column min-width="80px" property="Source" label="来源" fit :show-overflow-tooltip="true" align="center"></el-table-column>
                      <el-table-column v-if="activeName != 'five'" min-width="80px" property="Username" label="跟进人" fit :show-overflow-tooltip="true" align="center"></el-table-column>
                      <el-table-column v-if="activeName != 'five'" min-width="150px" property="DtInsertDate" label="跟进时间" fit :show-overflow-tooltip="true" align="center">
                        <template slot-scope="{ row }">
                          <span>{{
                            isNull(row.DtInsertDate)
                              ? ""
                              : row.DtInsertDate.replace("T", " ")
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column v-if="activeName != 'five'" min-width="80px" property="StrIsright" label="信息核实" fit :show-overflow-tooltip="true" align="center"></el-table-column>
                      <el-table-column v-if="activeName != 'five'" min-width="80px" property="Strintention" label="客户意向" fit :show-overflow-tooltip="true" align="center"></el-table-column>
                      <el-table-column v-if="activeName != 'five'" min-width="80px" property="Strdemand" label="当前需求" fit :show-overflow-tooltip="true" align="center"></el-table-column>
                      <el-table-column v-if="activeName != 'five'" min-width="120px" property="Remark" label="跟进信息" fit :show-overflow-tooltip="true" align="center"></el-table-column>
                      <el-table-column v-if="activeName == 'five'|| activeName == 'four'" min-width="150px" label="更新时间" align="center" fit :show-overflow-tooltip="true">
                        <template slot-scope="{ row }">
                          <span>{{
                            isNull(row.DtInsertDate)
                              ? ""
                              : row.DtInsertDate.replace("T", " ")
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column v-if="activeName != 'eight'" :width="activeName == 'seven'?'150px':'80px'" label="操作" align="center" fixed="right">
                        <template slot-scope="{ row }">
                          <el-button v-if="checkPermission(['marketingLead_followup'], permissionLists)&&(activeName != 'eight'&&activeName != 'seven')" size="mini" type="success" plain @click="followHandle(row)">跟进</el-button>
                          <el-button v-if="checkPermission(['marketingLead_followup'], permissionLists)&&(activeName == 'seven')&&((row.Isocean==1)||isNullZero(row.Isocean))" size="mini" type="success" plain @click="followHandle(row)">跟进</el-button>
                          <el-button v-if="checkPermission(['marketingLead_claim'], permissionLists)&&(activeName == 'seven')&&((row.Isocean==1)||isNullZero(row.Isocean))" size="mini" type="primary" plain @click="claimHandle(row)">认领</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div v-if="!isContactsByOther&&(!isNull(contactsList))">
                      <el-pagination @current-change="diaCurrentChange" :current-page.sync="comTelQuery.currpage" :page-size="comTelQuery.perpage" @size-change="diaSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager,next,jumper" :total="comTotal"></el-pagination>
                    </div>
                    <div v-show="isContactsByOther">
                      <div class="confirmTitle">查询联系方式</div>
                      <div class="btnBox flex">
                        <div class="confirmBtn cp" @click="confirmGetentContactnumbyother(scope.$index)">
                          确定
                        </div>
                        <div class="cancelBtn cp" @click="cancel(scope.row)">
                          取消
                        </div>
                      </div>
                    </div>
                    <img v-if="scope.row.haveTel == 1" src="../../assets/images/contacts.png" alt="" slot="reference" @click="getentcontactnum(scope.row)" title="查看联系人及联系方式" />
                    <img v-if="scope.row.haveTel == 0" src="../../assets/images/seach.png" alt="" slot="reference" @click="getentContactnumbyother(scope.row)" title="天眼查获取联系人及联系方式" />
                  </el-popover>
                  <span v-if="checkPermission(['marketingLead_followup'], permissionLists) && (activeName == 'five'||activeName == 'four')" class="m_plus_box" title="新增联系人" @click="addContacts(scope.row, '跟进')"><i class="el-icon-plus"></i></span>
                </span>
                <span v-else-if="item.StrColumName=='跟进时间' && activeName!='second'">
                  {{ isNull(scope.row[item.StrColumId]) ? '' : scope.row[item.StrColumId].replace('T',' ')}}
                </span>
                <span v-else-if="item.StrColumName == '认领状态'">
                  <span v-if="scope.row.strClaimstu == '1'">已认领</span>
                  <!-- <span v-if="(Number(scope.row.strClaimstu) < 1)||isNull(scope.row.strClaimstu)">未认领</span> -->
                  <span v-else>未认领</span>
                </span>
                <span v-else-if="
                    item.StrColumName == '跟进状态' && activeName != 'second'
                  ">
                  <span v-if="scope.row.ManualInputTel == 1">已跟进</span>
                  <span v-else>未跟进</span>
                </span>
                <span class="f_txt_span" v-else-if="item.StrColumName=='企业全称' && (activeName=='six'||activeName=='seven'||activeName=='eight')" title="点击可查看岗位详情" @click="postDtlHandle(scope.row)">{{ isNull(scope.row[item.StrColumId]) ? '' : scope.row[item.StrColumId]}}</span>
                <span v-else>{{
                  isNull(scope.row[item.StrColumId])
                    ? ""
                    : scope.row[item.StrColumId]
                }}</span>
              </template>
            </el-table-column>
          </template>
          <!-- <el-table-column prop="aaa" label="信息核对"></el-table-column> -->
        </el-table>
        <div class="block">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="listQuery.currpage" :page-size="listQuery.perpage" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="确定下载" :visible.sync="downVisible" width="450px">
      <div style="font-size: 14px">请确认，是否下载导出数据？</div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="downVisible = false">取消</button>
        <button class="search" @click="confirmDown" style="margin-left: 10px; font-weight: 600">
          确定
        </button>
      </span>
    </el-dialog>
    <!-- 新增联系人 -->
    <el-dialog :title="addContactTitle" :visible.sync="addContactsVisible" width="450px">
      <div class="formBox">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="联系人" prop="telpername">
            <el-input v-model="form.telpername" clearable></el-input>
          </el-form-item>
          <el-form-item label="职位" prop="telpernamepost">
            <el-select v-model="form.telpernamepost" placeholder="" clearable>
              <el-option label="人事" value="人事"></el-option>
              <el-option label="老板" value="老板"></el-option>
              <el-option label="部门负责人" value="部门负责人"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="联系方式" prop="telNum">
            <el-input v-model="form.telNum" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addContactsVisible = false" size="small">取 消</el-button>
        <el-button :loading="contactLoading" type="primary" @click="confirmAddContacts" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 已跟进状态下企业的岗位详情弹框 -->
    <el-dialog title="岗位详情" :visible.sync="postVisible" width="800px" class="post_dialog_box">
      <div class="m_box">
        <div class="post_form_box">
          <div class="post_forms">
            <span>岗位名称:</span>
            <el-input v-model="postQuery.strJobName" size="small" clearable></el-input>
          </div>
          <el-button type="primary" size="small" @click="dialogSearchHandle">搜索</el-button>
        </div>
        <el-table ref="clueTable" class="re_table" border v-loading="diatableLoading" :data="postData" style="width:100%">
          <template v-for="(item,index) in postTitleData">
            <el-table-column v-if="item.StrColumId!='StrQue'&&item.StrColumId!='haveTel1'&&item.StrColumId!='StrIsCRMgh'&&item.StrColumId!='Strcontaper'" :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="item.StrColumName=='联系人' ? false : true" :key="index" :min-width="item.StrColumName.indexOf('序号')>-1 ? '60px' : item.StrColumName.indexOf('全称')>-1?('250px'):(item.StrColumName.indexOf('简称')>-1||item.StrColumName.indexOf('时间')>-1?'160px':(item.StrColumName.indexOf('缺口')>-1?'72px':'100px'))" align="center">
              <template slot-scope="scope">
                <span v-if="item.StrColumId=='StrSource'" title="点击可跳转详情" @click="jumpOtherNet(scope.row.StrNation)" class="j_url_txt">{{ isNull(scope.row[item.StrColumId]) ? '' : scope.row[item.StrColumId]}}</span>
                <span v-else>{{ isNull(scope.row[item.StrColumId]) ? '' : scope.row[item.StrColumId]}}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <el-pagination @current-change="changeBPage1" :current-page.sync="postQuery.currpage" :page-size="postQuery.perpage" @size-change="handleSizeChange1" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager,next,jumper" :total="totalMem"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="postVisible = false" type="primary" size="small">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 添加跟进 -->
    <el-dialog title="跟进" :visible.sync="dialogFollowVisible" width="560px" :close-on-click-modal="false" class="t_dialog_box">
      <el-form :model="folDiaQuery" :rules="folrules" ref="folForm" label-width="100px" class="demo-query">
        <el-form-item label="企业名称:">
          <span>{{folDiaQuery.entname}}</span>
        </el-form-item>
        <el-form-item label="联系人:" prop="ContactPerson">
          <el-input v-model="folDiaQuery.ContactPerson" size="small" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="职位:" prop="ContactPsnpost">
          <el-select v-model="folDiaQuery.ContactPsnpost" size="small" placeholder="" clearable>
            <el-option label="人事" value="人事"></el-option>
            <el-option label="老板" value="老板"></el-option>
            <el-option label="部门负责人" value="部门负责人"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系方式:">
          <div class="t_tel_box">
            <span v-if="isTelNum">{{folDiaQuery.TelNum}}</span>
            <el-input v-if="!isTelNum&&(activeName=='six'||activeName=='seven')" v-model="folDiaQuery.TelNum" size="small" placeholder="" clearable></el-input>
            <i v-if="(activeName=='six'||activeName=='seven')" :title="isTelNum?'编辑联系方式':'取消编辑联系方式'" class="el-icon-edit edit01" @click="editIconHandle"></i>
          </div>
        </el-form-item>
        <el-form-item label="信息核对:" prop="StrIsright">
          <el-radio-group v-model="folDiaQuery.StrIsright" @change="rightChange">
            <el-radio :label="'信息准确'">信息准确</el-radio>
            <el-radio :label="'信息有误'">信息有误</el-radio>
            <el-radio :label="'未联系上'">未联系上</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="客户意向:" prop="Strintention" @change="intenChange" v-if="folDiaQuery.StrIsright == '信息准确'">
          <el-select v-model="folDiaQuery.Strintention" size="small" placeholder="" clearable>
            <el-option label="有意向" value="有意向"></el-option>
            <el-option label="无意向" value="无意向"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="当前需求:" prop="Strdemand" v-if="folDiaQuery.Strintention == '有意向'">
          <el-select v-model="folDiaQuery.Strdemand" size="small" placeholder="" clearable>
            <el-option label="有" value="有"></el-option>
            <el-option label="无" value="无"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跟进信息:">
          <el-input v-model="folDiaQuery.Remark" size="small" type="textarea" :rows="2" placeholder="" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFollowVisible = false" size="small">取 消</el-button>
        <el-button :loading="followLoading" type="primary" @click="confirmAddFollow" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 认领 -->
    <el-dialog title="认领" class="t_dialog_box01" :visible.sync="claimVisible" width="580px">
      <div class="adopt_box">
        <el-form :model="adoptQuery" label-width="80px">
          <el-form-item label="企业全称：">
            <span>{{adoptQuery.entname}}</span>
          </el-form-item>
          <el-form-item label="联系人：">
            <span>{{adoptQuery.ContactPerson}}</span>
          </el-form-item>
          <el-form-item label="职位：">
            <span>{{adoptQuery.ContactPsnpost}}</span>
          </el-form-item>
          <el-form-item label="联系方式：">
            <span>{{adoptQuery.TelNum}}</span>
          </el-form-item>
        </el-form>
        <p class="claim_txt">友情提示：点击认领后，该客户会同步至CRM系统，请在CRM系统中补全相关信息，以确保客户新建成功！！</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="claimVisible = false" size="small">取 消</el-button>
        <el-button :loading="adoptLoading" type="primary" @click="confirmClaimHandle" size="small">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改地区 -->
    <el-dialog title="修改地区" class="t_dialog_box01" :visible.sync="showeditArea" width="650px">
      <div class="adopt_box">
        <el-form :model="adoptQuery" :inline="true" label-width="60px">
          <el-form-item label="省：">
            <el-input v-model="province" style="width:200px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="市：">
            <el-input v-model="city" style="width:200px" size="small"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showeditArea = false" size="small">取 消</el-button>
        <el-button :loading="adoptLoading" type="primary" @click="confirmEditArea" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from "@/utils/permission"; // 权限判断函数
  export default {
    data() {
      return {
        followLoading: false,
        contactLoading: false,
        custPath: "",
        addContactTitle: "新增联系人",
        tablePath: this.$store.state.EMP.tablePath,
        scaleList: ["200人以上", "500人以上", "2000人以上", "5000人以上"],
        contactsList: [], //联系人列表
        contactsLoading: false,
        isContactsByOther: false, //是否是从其他渠道取联系方式
        info: {}, //点击按钮行的数据
        downVisible: false,
        btnLoading: false,
        activeName: "second",
        tableHeight: 0,
        showDropScreen: -1,
        tableData: [],
        // 客户线索参数
        listQuery: {
          strEntName: "", //公司名称
          strEnttype: "", //公司区分
          strJobName: "", //岗位名称
          StrEntScale: "", //企业规模
          strAddr: "", //地区
          StrEntIndustry: "", //行业
          strplatform: "", //采集平台
          strTableId: "",
          dtReleasetimepx: "", //更新时间排序 desc降序 asc升序
          JobNumpx: "", //缺口排序 desc降序 asc升序
          roletype: localStorage.loginRoletype,
          AddTelFollow: "",
          strTaskType: '1', //1蓝领 2猎头
          strintention: '', //客户意向
          strdemand: '', //需求
          strClaimstu: '', //认领状态 未认领 被认领
          followdatestart: '', //跟进时间
          followdateent: '', //跟进时间
          claimdatestart: '', //认领时间
          claimdateend: '', //认领时间
          followtype: '', //全部 已跟进 我的跟进 军嫂跟进
          followtypeCheck: false,
          followusername: '', //跟进人
          claimusername: '', //认领人
          currpage: 1,
          perpage: 10
        },
        // 导出参数
        exportQuery: {
          strEntName: "", //公司名称
          strEnttype: "", //公司区分
          strJobName: "", //岗位名称
          strAddr: "", //地区
          strplatform: "", //采集平台
          strTableId: "",
          dtReleasetimepx: "", //更新时间排序 desc降序 asc升序
          JobNumpx: "", //缺口排序 desc降序 asc升序
          roletype: localStorage.loginRoletype,
          AddTelFollow: "",
          strTaskType: '', //1蓝领 2猎头
          strintention: '', //客户意向
          strdemand: '', //需求
          strClaimstu: '', //认领状态 未认领 被认领
          followdatestart: '', //跟进时间
          followdateent: '', //跟进时间
          claimdatestart: '', //认领时间
          claimdateend: '', //认领时间
          followtype: '', //全部 已跟进 我的跟进 军嫂跟进
          currpage: 1,
          perpage: 1000000,
        },
        tableLoading: false,
        // 表头数据
        tableTitle: [],
        total: 0,
        // 任务列表
        taskList: [],
        taskQuery: {
          currpage: 1,
          perpage: 10,
          strplatform: "", //平台
          strTaskname: "",
        },
        // 采集平台
        platformList: [],
        platformQuery: {
          currpage: 1,
          perpage: 100,
          strTaskType: "1" //1蓝领 2猎头 
        },
        basicQuery: {
          keyword: "strEnttype", //strEnttype 单位类型
          currpage: 1,
          perpage: 10000
        },
        // 招聘单位类型
        typeList: [],
        loginRoletype: localStorage.loginRoletype,
        addContactsVisible: false,
        form: {
          EntId: "",
          telNum: "",
          telpername: "",
          telpernamepost: '',
          remark: ""
        },
        rules: {
          telpername: {
            required: true,
            message: "请输入联系人姓名",
            trigger: "blur",
          },
          telpernamepost: {
            required: true,
            message: "请选择职位",
            trigger: "change"
          },
          telNum: {
            required: true,
            message: "请输入联系方式",
            trigger: "blur"
          }
        },
        folrules: {
          ContactPerson: {
            required: true,
            message: "请输入联系人姓名",
            trigger: "blur",
          },
          ContactPsnpost: {
            required: true,
            message: "请选择职位",
            trigger: "change"
          },
          TelNum: {
            required: true,
            message: "请输入联系方式",
            trigger: "blur",
          },
          StrIsright: {
            required: true,
            message: "请选择信息核对",
            trigger: "change"
          },
          Strintention: {
            required: true,
            message: "请选择客户意向",
            trigger: "change"
          },
          Strdemand: {
            required: true,
            message: "请选择当前需求",
            trigger: "change"
          },
        },
        claimQuery: {
          strEntName: "",
          strEntAdd: "",
          strCustId: ''
        },
        // 按钮权限参数
        butQuery: {
          path: "/marketingRadar",
          powerEnName: "product",
        },
        permissionLists: [],
        // 选中的跟进状态
        statusCheckList: [],
        // 跟进状态列表
        baseInfoList: [],
        // 是否是vip
        isVip: false,
        // 岗位列表参数
        postQuery: {
          strEnttype: "", //公司区分
          strJobName: "", //岗位名称
          StrEntScale: "", //企业规模
          strAddr: "", //地区
          StrEntIndustry: "", //行业
          strplatform: "", //采集平台
          entId: '',
          roletype: localStorage.loginRoletype,
          currpage: 1,
          perpage: 10
        },
        postData: [],
        postTitleData: [], //岗位表头
        postVisible: false,
        diatableLoading: false,
        totalMem: 0,
        // 是否能看线索雷达
        isCanViewClue: false,
        // 是否能看猎头
        isCanViewHunt: false,
        // 查询企业联系方式参数
        comTelQuery: {
          GdEntId: '',
          strteltype: '', //跟进follow  其他查看looktel
          currpage: 1,
          perpage: 10
        },
        // 企业全称
        dialogEntName: '',
        // 企业地址
        dialogStrEntAdd: '',
        // 认领状态
        dialogStrClaimstu: '',
        comTotal: 0,
        dialogFollowVisible: false,
        // 跟进参数
        folDiaQuery: {
          EntId: '',
          entname: '', //企业名称
          TelNum: '', //手机号
          Source: '', //该条联系人的来源
          Sourceuserid: '', //创建联系人的userid
          ContactPerson: '', //联系人
          ContactPsnpost: '', //职位
          Strother: '', //传空
          StrIsright: '', //信息准确 信息有误
          Strintention: '', //客户意向
          Strdemand: '', //当前需求
          Remark: '' //跟进信息
        },
        // 认领弹框
        claimVisible: false,
        adoptQuery: {
          entname: '', //企业全称
          ContactPerson: '', //联系人
          ContactPsnpost: '', //职位
          TelNum: '' //联系方式
        },
        adoptLoading: false,
        isTelNum: true,
        renUsername: localStorage.userName,
        dialogClaimusername: '',
        IsdataAdmin: '0', //数据管理员权限
        areaInfo: {
          EntId: '',
          StrEntAdd: ''
        },
        province: '',
        city: '',
        showeditArea: false, //修改地区弹窗
      };
    },
    created() {
      this.calHeight();
      this.getTabsPower()
      // 获取任务列表
      // this.getTaskList();
      // 获取采集平台列表
      this.getPlatformList();
      // 获取基础信息
      this.getBasicList('strEnttype');
      this.getroleareaIsdataAdmin(); //判断 是否有数据管理员权限
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        xz.getbtnPowerIdBypage(this.butQuery).then((res) => {
          // console.log('按钮',res)
          if (res.status == "ok") {
            let resmsg = res.msg;
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = [];
            }
          } else {
            this.permissionLists = [];
          }
        });
      },
      getroleareaIsdataAdmin() {
        xz.getroleareaIsdataAdmin().then((res) => {
          if (res.status == "ok") {
            if (res.data == '1') {
              this.IsdataAdmin = '1';
            } else {
              this.IsdataAdmin = '0';
            }
          } else {
            this.IsdataAdmin = '0';
          }
        });
      },
      // 获取tab权限
      getTabsPower() {
        let actives = this.$route.query.activeName;
        let query = {
          currpage: 1,
          perpage: 10
        }
        let that = this
        xz.getpageroleList(query).then((res) => {
          // console.log('tab权限',res)
          if (res.status == "ok") {
            if (res.msg1 == '1') { // 有权限 2无权限
              that.isCanViewClue = true
            } else {
              that.isCanViewClue = false
            }
            if (res.msg2 == '1') { // 有权限 2无权限
              that.isCanViewHunt = true
            } else {
              that.isCanViewHunt = false
            }
            // 从别的页面跳转过来
            if (!that.isNull(actives)) {
              that.activeName = actives
              if ((that.isCanViewClue) && that.activeName != "second") {
                if (that.activeName == "five") {
                  that.listQuery.strTableId = "JBReptJobInf";
                  that.listQuery.followtype = "未跟进";
                  that.listQuery.strTaskType = "1";
                } else if (that.activeName == "six") {
                  that.listQuery.strTableId = "JBReptJobInfFo";
                  that.listQuery.followtype = "已跟进";
                  that.listQuery.strTaskType = "1";
                } else if (that.activeName == "seven") {
                  that.listQuery.strTableId = "JBReptJobInfmyfo";
                  that.listQuery.followtype = "我的跟进";
                  that.listQuery.strTaskType = "1";
                } else if (that.activeName == "eight") {
                  that.listQuery.strTableId = "JBReptJobInfClaim";
                  that.listQuery.followtype = "我的认领";
                  that.listQuery.strTaskType = "1";
                } else if (that.activeName == "four") {
                  that.listQuery.strTableId = "JBReptJobInf";
                  that.listQuery.followtype = "未跟进";
                  that.listQuery.strTaskType = "2";
                }
                that.getTableTitle(that.listQuery.strTableId);
              }
              if (that.activeName == "second") {
                that.listQuery.strTableId = "JBCrmEntInfo";
                that.getTableTitle(that.listQuery.strTableId);
              }
            } else {
              if (that.isCanViewClue) {
                that.activeName = "five";
                that.listQuery.followtype = "未跟进";
                that.listQuery.strTableId = "JBReptJobInf";
                that.listQuery.strTaskType = "1";
                that.getTableTitle(that.listQuery.strTableId);
              } else {
                // 获取CRM客户线索
                that.listQuery.strTableId = "JBCrmEntInfo";
                that.activeName = "second";
                that.listQuery.followtype = ''
                that.listQuery.strTaskType = "";
                that.getTableTitle(that.listQuery.strTableId);
              }
            }
          } else {
            that.activeName = "second";
            that.listQuery.strTableId = "JBCrmEntInfo";
            that.listQuery.followtype = ''
            that.listQuery.strTaskType = "";
            that.getTableTitle(that.listQuery.strTableId);
          }
          that.getButtonPower(); //按钮权限
          that.vipCheck();
        });
      },
      // 编辑跟进联系方式
      editIconHandle() {
        this.isTelNum = !this.isTelNum
      },
      // 搜索岗位详情
      dialogSearchHandle() {
        this.postQuery.currpage = 1
        this.getPostList();
      },
      // 点击查看岗位详情(已跟进)
      postDtlHandle(row) {
        // console.log('已跟进',row)
        this.postQuery.entId = row.GdEntId
        this.postVisible = true
        this.getPostTableTitle()
      },
      // 修改跟进状态
      bdChange(val) {
        let that = this
        if (that.activeName == "six") {
          if (val == true) {
            that.listQuery.followtype = "军嫂跟进";
          } else {
            that.listQuery.followtype = "已跟进";
          }
        }
        that.getTableTitle(that.listQuery.strTableId);
      },
      // 判断是否是VIP
      vipCheck() {
        let query = {
          keyword: 'strVIP',
          currpage: 1,
          perpage: 10000
        }
        xz.getJbBaseBasicdataList(query).then((res) => {
          // console.log('vip', res)
          if (res.status == 'ok') {
            let userid = Cookies.get("userid-b")
            let resmsg = res.msg
            this.isVip = resmsg.some(val => val.Basname == userid)
          } else {
            this.isVip = false
          }
        })
      },
      // 获取岗位表头
      getPostTableTitle() {
        xz.getEcrmColumnList('JBReptJobInf', '').then((res) => {
          // console.log('tableTitle', res)
          if (res.status == "ok") {
            this.postTitleData = res.msg;
            this.getPostList();
          } else {
            this.postTitleData = [];
          }
        });
      },
      // 获取跟进中的岗位列表
      getPostList() {
        this.diatableLoading = true
        xz.getjobByentidLists(this.postQuery).then((res) => {
          // console.log('vip', res)
          if (res.status == 'ok') {
            this.postData = res.msg
            this.totalMem = res.totalcount
          } else {
            this.postData = []
            this.totalMem = 0
          }
          this.diatableLoading = false
        })
      },
      //岗位详情分页
      changeBPage1(val) {
        this.postQuery.currpage = Number(val)
        this.getPostList()
      },
      handleSizeChange1(val) {
        this.postQuery.currpage = 1
        this.postQuery.perpage = Number(val)
        this.getPostList()
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        // console.log('height', this.tableHeight)
      },
      // 确定认领
      confirmClaimHandle() {
        // console.log('ddd',this.claimQuery)
        this.adoptLoading = true
        xz.sendDataToCrm(this.claimQuery).then((res) => {
          // console.log('ddd',res)
          if (res.errorCode == "0") {
            this.$message({
              type: "success",
              message: "认领成功"
            });
            this.claimVisible = false
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: "认领失败,请稍后再试"
            });
          }
          this.adoptLoading = false
        });
      },
      // 认领
      claimHandle(item) {
        // console.log('item',item)
        this.claimQuery.strEntName = item.entname; //企业全称StrEntNice
        this.claimQuery.strEntAdd = item.StrEntAdd
        this.claimQuery.strCustId = item.EntId //GdEntId
        this.adoptQuery = {
          entname: item.entname, //企业全称
          ContactPerson: item.ContactPerson, //联系人
          ContactPsnpost: item.ContactPsnpost, //职位
          TelNum: item.TelNum //联系方式
        }
        this.claimVisible = true
      },
      // 导出
      exportHandle() {
        this.exportQuery = JSON.parse(JSON.stringify(this.listQuery));
        this.exportQuery.currpage = 1;
        this.exportQuery.perpage = 1000000;
        this.btnLoading = true;
        // console.log('ll',param)
        xz.outputEcrmList(this.listQuery.strTableId, this.exportQuery).then(
          (res) => {
            // console.log('ll',res)
            if (res.status == "ok") {
              this.custPath = res.stroutpath;
              this.downVisible = true;
            } else {
              this.$message({
                type: "error",
                message: "导出失败，请稍后再试",
              });
              return false;
            }
            this.btnLoading = false;
          }
        );
      },
      // 确定下载导出数据
      confirmDown() {
        let path = this.tablePath + this.custPath;
        const aTag = document.createElement("a");
        aTag.href = path;
        aTag.click();
        this.downVisible = false;
      },
      handleClick(tab) {
        // console.log('tab', tab)
        this.activeName = tab.name;
        this.listQuery = this.$options.data.call(this).listQuery;
        this.listQuery.currpage = 1;
        if (this.activeName == "second") {
          // 获取CRM客户线索
          this.contactsList = [];
          this.listQuery.strTableId = "JBCrmEntInfo";
          this.listQuery.followtype = ''
          this.getTableTitle(this.listQuery.strTableId);
        } else if (this.activeName == "five") {
          // 获取潜在客户线索
          this.contactsList = [];
          this.tableData = [];
          this.tableTitle = [];
          this.listQuery.strTaskType = '1'
          this.listQuery.strTableId = "JBReptJobInf";
          this.listQuery.followtype = '未跟进'
          this.getTableTitle(this.listQuery.strTableId);
          // 获取采集平台列表
          this.platformQuery.strTaskType = '1'
          this.getPlatformList();
        } else if (this.activeName == "six") {
          this.contactsList = [];
          this.tableData = [];
          this.tableTitle = [];
          this.listQuery.strTableId = "JBReptJobInfFo";
          this.listQuery.followtype = '已跟进'
          this.getTableTitle(this.listQuery.strTableId);
          // 获取采集平台列表
          this.platformQuery.strTaskType = '1'
          this.getPlatformList();
        } else if (this.activeName == "seven") {
          this.contactsList = [];
          this.tableData = [];
          this.tableTitle = [];
          this.listQuery.strTableId = "JBReptJobInfmyfo";
          this.listQuery.followtype = '我的跟进'
          this.getTableTitle(this.listQuery.strTableId);
          // 获取采集平台列表
          this.platformQuery.strTaskType = '1'
          this.getPlatformList();
        } else if (this.activeName == "eight") {
          this.contactsList = [];
          this.tableData = [];
          this.tableTitle = [];
          this.listQuery.strTableId = "JBReptJobInfClaim";
          this.listQuery.followtype = '我的认领'
          this.getTableTitle(this.listQuery.strTableId);
          // 获取采集平台列表
          this.platformQuery.strTaskType = '1'
          this.getPlatformList();
        } else if (this.activeName == "four") {
          // 获取猎头线索雷达
          this.contactsList = [];
          this.tableData = [];
          this.tableTitle = [];
          this.listQuery.strTaskType = '2'
          this.listQuery.strTableId = "JBReptJobInf";
          this.listQuery.followtype = '未跟进'
          this.getTableTitle(this.listQuery.strTableId);
          // 获取采集平台列表
          this.platformQuery.strTaskType = '2'
          this.getPlatformList();
        } else if (this.activeName == "全部跟进") {
          this.contactsList = [];
          this.tableData = [];
          this.tableTitle = [];
          this.listQuery.strTableId = "JBReptJobInfALL";
          this.listQuery.followtype = '全部跟进'
          this.getTableTitle(this.listQuery.strTableId);
          // 获取采集平台列表
          this.platformQuery.strTaskType = '1'
          this.getPlatformList();
        } else if (this.activeName == "全部认领") {
          this.contactsList = [];
          this.tableData = [];
          this.tableTitle = [];
          this.listQuery.strTableId = "JBReptJobInfALLClaim";
          this.listQuery.followtype = '全部认领'
          this.getTableTitle(this.listQuery.strTableId);
          // 获取采集平台列表
          this.platformQuery.strTaskType = '1'
          this.getPlatformList();
        }
      },
      // 跳转岗位详情页
      jumpOtherNet(url) {
        // let routeData = this.$router.resolve({ path: '/login',query: {loginName}});
        // window.open(routeData.href, '_blank');
        // let path = window.location.protocol+'//' + url
        // window.location.href = path
        window.open(url, "_blank");
      },
      // 获取列表
      getList() {
        this.tableLoading = true;
        let that = this
        let pagename;
        if (that.activeName != 'second') { //线索雷达
          pagename = 'getyxldjobLists'
        } else {
          pagename = 'getpotentialLists' //crm
        }
        xz.getCusLeadsLists(this.listQuery, pagename).then((res) => {
          // console.log('getList', res)
          if (res.status == "ok") {
            this.tableData = res.msg;
            this.total = Number(res.totalcount);
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.tableLoading = false;
        });
      },
      //分页
      handleCurrentChange(val) {
        this.listQuery.currpage = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.currpage = 1;
        this.listQuery.perpage = Number(val);
        this.getList();
      },
      sortHandle(column) {
        //order-- ascending 升序、descending 降序、 null 默认排序
        console.log("oo", this.listQuery, column);
        if (column.prop == "IntJobNum") {
          //缺口
          this.listQuery.dtReleasetimepx = "";
          if (column.order == "ascending") {
            this.listQuery.JobNumpx = "asc";
          } else {
            this.listQuery.JobNumpx = "desc";
          }
        }
        if (column.prop == "DtReleasetime") {
          //更新时间
          this.listQuery.JobNumpx = "";
          if (column.order == "ascending") {
            this.listQuery.dtReleasetimepx = "asc";
          } else {
            this.listQuery.dtReleasetimepx = "desc";
          }
        }
        this.getList();
      },
      // 数据排序
      sortMethod() {
        this.getList();
      },
      // 获取表头
      getTableTitle(strTableId) {
        xz.getEcrmColumnList(strTableId, "").then((res) => {
          // console.log('tableTitle', res)
          if (res.status == "ok") {
            this.tableTitle = res.msg;
            this.getList(this.listQuery);
          } else {
            this.tableTitle = [];
          }
        });
      },
      // 获取采集平台列表
      getPlatformList() {
        this.platformList = [];
        xz.getstrplatformsearch(this.platformQuery).then((res) => {
          // console.log('platformList', res)
          if (res.status == "ok") {
            this.platformList = res.msg
          } else {
            this.platformList = [];
          }
        });
      },
      // 获取基础信息
      getBasicList(type) {
        this.basicQuery.keyword = type
        xz.getJbBaseBasicdataList(this.basicQuery).then((res) => {
          // console.log('typeList', res)
          if (res.status == "ok") {
            if (type == 'strEnttype') { // 单位类型
              this.typeList = res.msg;
            }
          } else {
            if (type == 'strEnttype') { // 单位类型
              this.typeList = [];
            }
          }
        });
      },
      // 搜索
      searchHandle() {
        this.listQuery.currpage = 1;
        this.getList(this.listQuery);
      },
      // 清空
      resetHandle() {
        let that = this
        this.listQuery = this.$options.data.call(this).listQuery;
        if (that.activeName == "five") {
          that.listQuery.strTableId = "JBReptJobInf";
          that.listQuery.followtype = "未跟进";
          that.listQuery.strTaskType = "1";
        } else if (that.activeName == "six") {
          that.listQuery.strTableId = "JBReptJobInfFo";
          that.listQuery.followtype = "已跟进";
          that.listQuery.strTaskType = "1";
        } else if (that.activeName == "seven") {
          that.listQuery.strTableId = "JBReptJobInfmyfo";
          that.listQuery.followtype = "我的跟进";
          that.listQuery.strTaskType = "1";
        } else if (that.activeName == "eight") {
          that.listQuery.strTableId = "JBReptJobInfClaim";
          that.listQuery.followtype = "我的认领";
          that.listQuery.strTaskType = "1";
        } else if (that.activeName == "four") {
          that.listQuery.strTableId = "JBReptJobInf";
          that.listQuery.followtype = "未跟进";
          that.listQuery.strTaskType = "2";
        } else if (this.activeName == "second") {
          // 获取CRM客户线索
          that.listQuery.strTableId = "JBCrmEntInfo";
          that.listQuery.followtype = ''
          that.listQuery.strTaskType = "";
        }
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //判断是否为空
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN"
        );
      },
      //判断是否为空
      isNullZero(o) {
        return (
          o === undefined ||
          o === "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o === null ||
          o === "" ||
          o === "null" ||
          o === "NaN"
        );
      },
      // 跟进
      followHandle(row) {
        // console.log('22',row)
        this.folDiaQuery.ContactPerson = row.ContactPerson
        this.folDiaQuery.ContactPsnpost = row.ContactPsnpost
        this.folDiaQuery.Sourceuserid = row.Sourceuserid
        this.folDiaQuery.TelNum = row.TelNum
        this.folDiaQuery.Source = row.Source
        this.folDiaQuery.StrIsright = ''
        this.folDiaQuery.Strintention = ''
        this.folDiaQuery.Strdemand = ''
        this.folDiaQuery.Remark = ''
        this.folDiaQuery.entname = row.entname
        this.dialogFollowVisible = true
      },
      // 确认跟进
      confirmAddFollow() {
        this.$refs['folForm'].validate((valid) => {
          if (valid) {
            // console.log('ff',this.folDiaQuery)
            this.followLoading = true
            xz.addEntfollowNum(this.folDiaQuery).then((res) => {
              if (res.status == "ok") {
                this.$message.success("操作成功！");
                this.dialogFollowVisible = false;
                this.getList(this.listQuery);
              } else {
                this.$message.error('操作失败！');
              }
              this.followLoading = false
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      //获取联系人和联系方式
      getentcontactnum(item) {
        this.isContactsByOther = false;
        this.folDiaQuery.EntId = item.GdEntId
        this.comTelQuery.GdEntId = item.GdEntId
        this.dialogEntName = item.StrEntNice
        this.dialogStrEntAdd = item.hasOwnProperty('StrEntAdd') == true ? item.StrEntAdd : ''
        this.dialogStrClaimstu = item.hasOwnProperty('strClaimstu') == true ? item.strClaimstu : '0'
        this.dialogClaimusername = item.hasOwnProperty('claimusername') == true ? item.claimusername : ''
        if (this.activeName == 'five' || this.activeName == 'four') {
          this.comTelQuery.strteltype = 'looktel'
        } else {
          this.comTelQuery.strteltype = 'follow'
        }
        this.getTelData(item.StrEntNice, this.dialogStrEntAdd, this.dialogStrClaimstu, this.dialogClaimusername);
        this.clickRecordHandle(item);
      },
      getentContactnumbyother(item) {
        // console.log('222',item);
        this.isContactsByOther = true;
        this.comTelQuery.GdEntId = item.GdEntId
        this.folDiaQuery.EntId = item.GdEntId
        this.info = item;
        this.dialogEntName = item.StrEntNice
        this.dialogStrEntAdd = item.hasOwnProperty('StrEntAdd') == true ? item.StrEntAdd : ''
        this.dialogStrClaimstu = item.hasOwnProperty('strClaimstu') == true ? item.strClaimstu : '0'
        this.dialogClaimusername = item.hasOwnProperty('claimusername') == true ? item.claimusername : ''
        this.clickRecordHandle(item);
      },
      // 修改信息核对
      rightChange(val) {
        // console.log('核对',val);
        if (val == '信息有误') {
          this.folDiaQuery.Strintention = ''
          this.folDiaQuery.Strdemand = ''
        }
      },
      // 修改客户意向
      intenChange(val) {
        // console.log('11',val);
        if (val == '无意向') {
          this.folDiaQuery.Strdemand = ''
        }
      },
      //其他方式取联系方式
      confirmGetentContactnumbyother(index) {
        // console.log('其他',index);
        this.$set(this.tableData[index], "haveTel", 1);
        this.$set(this.tableData[index], 'isThirdTel', 'sure');
        this.isContactsByOther = false;
        if (this.activeName == 'five' || this.activeName == 'four') {
          this.comTelQuery.strteltype = 'looktel'
        } else {
          this.comTelQuery.strteltype = 'follow'
        }
        this.getThirdView(this.dialogEntName);
        // this.getTelData(this.dialogEntName,this.dialogStrEntAdd,this.dialogStrClaimstu);
      },
      // 天眼查或其他三方查询联系人
      getThirdView(StrEntNice) {
        let that = this
        xz.getentContactnumbyother(StrEntNice).then((res) => {
          if (res.status == "ok") {
            that.getTelData(StrEntNice, that.dialogStrEntAdd, that.dialogStrClaimstu, that.dialogClaimusername);
          } else {
            that.contactsList = [];
          }
        });
      },
      // 点击联系人保存记录(点击次数)
      clickRecordHandle(item) {
        let query = {
          entId: item.GdEntId, //企业id
          jobid: item.GdJobId ? item.GdJobId : '' //岗位id
        }
        xz.addlookEntContact(query).then((res) => {
          if (res.status == "ok") {

          }
        });
      },
      // 查询企业联系方式
      getTelData(item, address, strClaimstu, claimusername) {
        let that = this
        this.contactsLoading = true;
        // that.contactsList = []
        xz.getEntContactlist(this.comTelQuery).then((res) => {
          if (res.status == "ok") {
            this.contactsList = res.data;
            for (let i = 0; i < res.data.length; i++) {
              let element = res.data[i];
              that.$set(element, "entname", item);
              that.$set(element, "StrEntAdd", address);
              that.$set(element, "strClaimstu", strClaimstu);
              that.$set(element, "claimusername", claimusername);
            }
            this.comTotal = Number(res.totalcount)
          } else {
            this.contactsList = [];
            this.comTotal = 0
          }
          this.contactsLoading = false;
        });
      },
      //分页
      diaCurrentChange(val) {
        this.comTelQuery.currpage = Number(val);
        this.getTelData(this.dialogEntName, this.dialogStrEntAdd, this.dialogStrClaimstu, this.dialogClaimusername);
      },
      diaSizeChange(val) {
        this.comTelQuery.currpage = 1;
        this.comTelQuery.perpage = Number(val);
        this.getTelData(this.dialogEntName, this.dialogStrEntAdd, this.dialogStrClaimstu, this.dialogClaimusername);
      },
      cancel(scope) {
        // this.$refs[`popover-${scope.StrQue}`][0].doClose();//不能检测到ref的值变化 不能触发视图更新
        document.body.click()
      },
      addContacts(row) {
        this.form = {
          EntId: "",
          telNum: "",
          telpername: "",
          telpernamepost: '',
          remark: ""
        };
        this.form.EntId = row.GdEntId;
        this.addContactsVisible = true;
      },
      confirmAddContacts() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            // console.log('ff',this.form)
            this.contactLoading = true
            xz.addEntcontactnum(this.form).then((res) => {
              if (res.status == "ok") {
                this.$message.success("添加成功！");
                this.addContactsVisible = false;
                this.getList(this.listQuery);
              } else {
                this.$message.error(res.msg);
              }
              this.contactLoading = false
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      editAreaInfo(row, column, cell) {
        console.log(row, column, cell)
        if (this, this.activeName == 'six'|| this.activeName == 'seven') {
          if (column.label == '地区') {
            if (row.StrEntAdd && row.StrEntAdd.indexOf('-') > -1) {
              this.province = row.StrEntAdd.split('-')[0]
              this.city = row.StrEntAdd.split('-')[1]
            }else{
              this.province = ''
              this.city = ''
            }
            this.areaInfo = {
              EntId: row.GdEntId,
              StrEntAdd: ''
            }
            this.showeditArea = true;
          }
        }
      },
      confirmEditArea() {
        if (this.province && this.city) {
          this.areaInfo.StrEntAdd = this.province + '-' + this.city;
          xz.updataEntfolloEntAdd(this.areaInfo).then((res) => {
            if (res.status == "ok") {
              this.getList();
              this.$message.success('修改成功！');
              this.showeditArea = false;
            } else {
              this.$message.error('系统出错！');
              this.showeditArea = false;
            }
          })
        } else {
          this.$message.warning('请填写省和市')
        }
      }
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .t_tel_box {
    display: flex;
    align-items: center;
  }

  .edit01 {
    color: #19bd92;
    font-size: 18px;
    margin-left: 8px;
    cursor: pointer;
  }

  .claim_txt {
    color: #F56C6C;
    font-weight: bold;
  }

  .m_plus_box {
    display: inline-block;
    width: 21px;
    height: 20px;
    line-height: 20px;
    border: 1px solid #666;
    border-radius: 3px;
    font-size: 20px;
    margin-left: 20px;
    color: #666;
    vertical-align: super;
    text-align: center;
  }

  .t_down_box {
    display: flex;
    align-items: center;
  }

  .post_form_box {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }

  .post_form_box .post_forms {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-right: 10px;
  }

  .f_txt_span {
    color: #19bd92;
    cursor: pointer;
  }

  .j_url_txt {
    /* color:#67C23A; */
    text-decoration: underline;
    cursor: pointer;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .main-con {
    background-color: #f3f3f3;
    padding: 0px 15px 15px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .contacts img {
    width: 24px;
    height: 24px;
  }

  .confirmTitle {
    padding: 14px 5px;
  }

  .cancelBtn {
    color: #409eff;
    margin-right: 53px;
  }

  .confirmBtn {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    width: 55px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 5px;
  }

  .btnBox {
    width: 100%;
    flex-direction: row-reverse;
    align-items: center;
    font-size: 13px;
  }

  .formBox {
    width: 360px;
  }
</style>
<style>
  .p_market_lead .formBox .el-form-item__content,
  .p_market_lead .formBox .el-select {
    width: 280px;
  }

  .adopt_box .el-form-item__label {
    color: #000;
  }

  .el-popover.market_popover_box {
    left: calc(100% - 790px) !important;
  }

  .t_dialog_box .el-dialog__body {
    padding: 0 20px;
  }

  .t_dialog_box01 .el-dialog__body {
    padding: 0 20px;
  }

  .t_dialog_box01 .el-form-item {
    margin-bottom: 3px;
  }

  .post_form_box .el-input {
    width: 200px;
  }

  .p_clue_box .el-table__row.current-row .f_txt_span {
    color: #fff;
  }

  .p_market_module.p_market_lead .el-radio__label {
    padding-left: 3px;
  }

  .p_market_module.p_market_lead .m_checks {
    margin-left: 5px;
    padding-top: 3px;
  }

  .p_market_module.p_market_lead .el-radio {
    margin-right: 6px;
    vertical-align: bottom;
  }

  .p_market_module .screenInputs .screenInput {
    margin: 0 0 10px 2px;
  }

  .p_market_module.p_market_lead .screenInputs .flname {
    min-width: 40px;
  }

  .post_dialog_box .el-table__body-wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  /*
主要是靠这个 注意
上面.el-table__body-wrapper::-webkit-scrollbar 是 10px 下面这个也要
*/
  .post_dialog_box .el-scrollbar__wrap::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  /*滚动条的滑块*/
  .post_dialog_box .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #a1a3a9;
    border-radius: 3px;
  }

  .p_pop_box.el-table .el-table__cell {
    padding: 3px 0;
  }

  .p_market_module .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #c0c4cc;
  }

  .p_market_module .el-table .descending .sort-caret.descending {
    border-top-color: #c0c4cc;
  }

  .p_market_module .th_input_label .el-form-item__label {
    width: 66px !important;
  }

  .p_market_module .el-form-item__label {
    padding: 0 5px 0 0;
  }

  .p_market_module .el-tabs {
    background-color: #fff;
    padding: 0 10px;
  }

  .p_market_module .screenInputs .screenInput {
    margin: 0 0 10px 5px;
  }

  .p_market_module .screenInputs .screenInput .el-select .el-input__inner,
  .p_market_module .re_down_form.el-form--inline .el-form-item__content,
  .p_market_module .re_down_form .el-select,
  .p_market_module .re_down_form .el-form-item__content,
  .p_market_module .screenInput .el-input {
    width: 200px !important;
  }

  .p_market_module .pro_down_box .el-date-editor.el-input {
    width: 140px !important;
  }

  .p_market_module .re_down_form.el-form--inline .f_cont_box .el-form-item__content {
    width: 50% !important;
  }

  .re_table.el-table .cell {
    padding: 0 5px;
  }

  .re_table.el-table .el-table__cell {
    padding: 3px 0;
  }

  .p_market_module .r_dropDownScreen .el-select .el-input .el-select__caret {
    line-height: 40px;
  }
</style>